import {Injectable} from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class ItemsDashboardAutorizacionesService {
    constructor() {
    }
    ngOnInit() {
    }
    getItemsProfesionales() {
        return [
            {
                title: 'Primera vez',
                routerLink: ['/#'],
                imageSrc: '/assets/demo/images/logos/iconos/obrero.png',
                bgColor: 'bg-blue-500'
            },
            {
                title: 'Renovación',
                routerLink: ['/#'],
                imageSrc: '/assets/demo/images/logos/iconos/renovar.png',
                bgColor: 'bg-green-500'
            },
            {
                title: 'Unificación',
                routerLink: ['/#'],
                imageSrc: '/assets/demo/images/logos/iconos/unificacion.png',
                bgColor: 'bg-yellow-500'
            },
            {
                title: 'Homologación',
                routerLink: ['/#'],
                imageSrc: '/assets/demo/images/logos/iconos/homologar.png',
                bgColor: 'bg-gray-400'
            }
        ];
    }
}
